import { graphql, useStaticQuery } from "gatsby";

export const usePopUps = () => {
  const data: PopUpData = useStaticQuery(graphql`
    query usePopUps {
      allWpPopUp {
        nodes {
          id
          slug
          date
          title
          pageLocations {
            nodes {
              slug
              id
            }
          }
          featuredImage {
            node {
              title
              altText
              gatsbyImage(
                quality: 100
                width: 1080
                breakpoints: 2
                formats: WEBP
              )
            }
          }
          popupInformation {
            from
            to
            redirections {
              toggler
              link
              title
              type
            }
          }
        }
      }
    }
  `);

  const filterPopupsByDate = (popups: PopupNode[]): PopupNode[] => {
    const now = new Date();

    const filteredPopups: { [key: string]: PopupNode } = {};

    popups.forEach((popup) => {
      const fromDate = new Date(popup.popupInformation.from);
      const toDate = new Date(popup.popupInformation.to);

      if (now >= fromDate && now <= toDate) {
        if (
          !filteredPopups[popup.slug] ||
          new Date(popup.date) > new Date(filteredPopups[popup.slug].date)
        ) {
          filteredPopups[popup.slug] = popup;
        }
      }
    });

    return Object.values(filteredPopups);
  };

  const getlocationPopUps = (popups: PopupNode[]) => {
    const validPopups = filterPopupsByDate(popups);

    const locationPopUps: { [key: string]: PopupNode[] } = {};
    const defaultPopUps: PopupNode[] = [];

    validPopups.forEach((popup) => {
      if (popup.pageLocations.nodes.length > 0) {
        popup.pageLocations.nodes.forEach((page) => {
          if (!locationPopUps[page.slug]) {
            locationPopUps[page.slug] = [];
          }
          locationPopUps[page.slug].push(popup);
        });
      } else {
        defaultPopUps.push(popup);
      }
    });

    return { locationPopUps, defaultPopUps };
  };

  return getlocationPopUps(data.allWpPopUp.nodes);
};
